<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="dataCenter-content">全力挖掘数据价值，赋能中小系统开发商和行业龙头企业，帮助其产品快速SaaS化和持续创新将传统系统中位于后端的通用模块抽离，整合数据技术、产品技术能力，提供统一的数据和服务，强力支撑前台业务从而使中小开发商不再受限于PaaS层的承载能力，将研发资源专心于业务应用层的开发，快速响应客户需求</p>
    <product-content
      :productContentArr = product
    />
    <div class="application">
      <p class="title">应用模式</p>
      <img :src="i6" alt="">
    </div>
    <brand :brandStyle="brandStyle"/>
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/dataCenter/1.png'
import i2 from '../assets/images/dataCenter/2.png'
import i3 from '../assets/images/dataCenter/3.png'
import i4 from '../assets/images/dataCenter/4.png'
import i5 from '../assets/images/dataCenter/5.png'
import i6 from '../assets/images/dataCenter/6.png'
export default {
  data () {
    return {
      product: [
        {img: i1, content: '通过数据标准体系建设方法论+数据指标系统，统一数据指标口径，消除数据二义性', label: '统一数据标准', type: 'left', style: 'width: 1.77rem;padding-left: 0.45rem;'},
        {img: i2, content: '统一对外数据服务接口，实现所有需求，一个接口', label: '统一数据服务', type: 'right', style: 'width: 1.77rem;padding-right: 0.45rem;'},
        {img: i3, content: '提供企业级数据资产管理平台，并通过数据地图与数据血缘实现360°数据全链路追踪', label: '统一数据资产', type: 'left', style: 'width: 1.77rem;padding-left: 0.45rem;'},
        {img: i4, content: '通过数据标准体系建设方法论+数据指标系统，统一数据指标口径，消除数据二义性', label: '统一开发平台', type: 'right', style: 'width: 1.77rem;padding-right: 0.45rem;'}
      ],
      bannerObj: {
        img: i5,
        title: '数据中台',
        content: '以强力中台（PaaS）支撑业务前台（SaaS），细化专业分工，快速响应客户，沉淀数据资产',
        button: '业务咨询'
      },
      topIndex: 1,
      childrenIndex: 1,
      i6: i6,
      brandStyle: 'background:rbga(255,255,255,1);',
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    dialogBusiness,
    footerA
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.dataCenter-content{
  width: 1040px;
  margin: 110px auto 60px;
  font-size:20px;
  font-family:PingFang SC;
  font-weight:500;
  line-height:35px;
  color:rgba(102,102,102,1);
}
.application{
  background:rgba(247,248,248,1);
  padding-bottom: 110px;
  text-align: center;
}
.application .title{
  font-size:34px;
  font-family:PingFang SC;
  font-weight:bold;
  line-height:60px;
  color:rgba(51,51,51,1);
  padding: 110px 0;
}
.application img{
  width: 1284px;
}
</style>



// WEBPACK FOOTER //
// src/view/dataCenter.vue